import { HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { TokenService } from 'src/app/shared/service/token.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-order-status-list',
  templateUrl: './order-status-list.component.html',
  styleUrls: ['./order-status-list.component.scss']
})
export class OrderStatusListComponent implements OnInit {

  public menus = [];
  public selected = [];
  OrderStatusList;
  isLoading;
  isDeleting;
  DeletingItem;

  constructor(private router: Router, private http: HttpClient, private toastr: ToastrService, private modalService: NgbModal,private TokenService: TokenService) {
    const a = JSON.parse(this.TokenService.getUser().Authority);
    if (!a['OrderStatus']) {
      router.navigateByUrl('/');
    }
  }


  ngOnInit() {
    this.GetOrderStatusList();
  }

  GetOrderStatusList() {
    this.http.get<any>(environment.url + 'Order/GetOrderStatus').subscribe(data => {
      this.OrderStatusList = data;
      this.isLoading = true;
    });
  }
  DeleteOrderStatus() {
    this.isDeleting = true;
    var body = { StatusRef: this.DeletingItem };
    this.http.post<any>(environment.url + 'Order/DeleteOrderStatus', body).subscribe(data => {
      this.isDeleting = false;
      this.DeletingItem = "";
      this.GetOrderStatusList();
      if (!data.Error) {
        this.modalService.dismissAll();
        this.toastr.success("Sipariş Durumu Silindi", '', {
          timeOut: 3000,
        });
      }
      else {
        this.toastr.error("Sipariş Durumu Silinemedi", 'Hata !', {
          timeOut: 3000,
        });
      }
    });
  }
  gotoOrderStatusEdit(item: any) {
    const navigatioExtra: NavigationExtras = {
      queryParams: { id: item }
    }
    this.router.navigate(['/home/definitions/edit-order-status'], navigatioExtra);
  }
  DeleteOrderStatusModal(file,ref) {
    this.DeletingItem = ref;
    this.modalService.open(file, { centered: true });
  }
  CloseDeleteModalClose(){
    this.modalService.dismissAll();
    this.DeletingItem = "";
  }
}
